import { render, staticRenderFns } from "./SiteAdminM.vue?vue&type=template&id=21243da1&"
import script from "./SiteAdminM.vue?vue&type=script&lang=ts&"
export * from "./SiteAdminM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports